<div
  class="cell-renderer"
  [ngStyle]="{ 'background-color': backgroundColor, color: fontColor }"
>
  {{ value }}
</div>
